import ThisModule from "./ReadMoreText";

export default ThisModule;
